import util from '@bmp-vue/core/api/util'

const controller = 'OnboardingContas'
export default Object.assign({}, util.GetCrud(controller, null), {
    ListarOnboardingContas: function (dto) {
        return util.Axios.GetAll(controller, dto);
    },
    ObterOnboardingCorrentistaConcluidoPorCodigoConta: function (codigoConta, documentoFederal) {
        return util.Axios.Get(`${controller}/conta/${codigoConta}/correntista/${documentoFederal}/concluido`);
    },
    ObterUltimoOnboardingConcluidoPorDocFederal: function (documentoFederal, isSocio = false) {
        return util.Axios.Get(`${controller}/correntista/${documentoFederal}/ultimo-concluido?socio=${isSocio}`);
    },
    RegistrarVisto: function (dto) {
        return util.Axios.Post(controller + '/registrar-visto', dto);
    },
    ObterVisto: function (params) {
        const compUrl = new URLSearchParams(params).toString();
        return util.Axios.Get(controller + '/visto?' + compUrl);
    },
    Finalizar: function (dto) {
        return util.Axios.Post(controller + '/finalizar', dto);
    },
    VincularTermoAberturaConta: function (dto) {
        return util.Axios.Post(controller + '/conta-termo-abertura', dto);
    }
})
